import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"

import "./Footer.scss"
import Half_Planet from "./assets/images/earth_half.png"
import Space_Station from "./assets/images/space_station.png"
import Planet_Purple from "./assets/images/planet_purple.png"
import space_shuttle from "./assets/gifs/space_shuttle.gif"
import { Container, Row, Col } from "react-bootstrap"
import icon1 from "./assets/images/discord-circle.svg"
import icon2 from "./assets/images/instagram-circle.svg"
import icon3 from "./assets/images/opensea-circle.svg"
import icon4 from "./assets/images/twitter-circle.svg"

const Footer = () => {
  let history = useHistory()
  const [hide, setHide] = useState(false)

  useEffect(() => {
    if (history.location.pathname == "/dashboard") {
      setHide(true)
    } else {
      setHide(false)
    }
  }, [history.location.pathname])

  return (
    <>

      <div className='footer_section' style={{ display: hide ? "none" : null }}>

        <div className='center_img'>
          <img className='half_planet' src={Half_Planet} alt='half_planet'></img>
        </div>
        <div className='space_station'>
          <img className='space_station' src={Space_Station} alt='space_station'></img>
        </div>
        <div className='space_shuttle'>
          <img className='space_shuttle' src={space_shuttle} alt='space_shuttle'></img>
        </div>
        <div className='footer_div'>
          <Container>
            <Row className='footer_desc'>
              <Col xl={4} className='footer_content'>
                <dl>
                  <dt>Mint</dt>
                  <dt>Known facts</dt>
                  <dt>Species</dt>
                </dl>
              </Col>
              <Col xl={4} className='footer_content'><dl>
                <dt>The Sandaga project</dt>
                <dt>How to buy NFTs</dt>
                <dt>Discord Leaderboards</dt>
              </dl></Col>
              <Col xl={4} className='footer_content'><dl>
                <dt>Make your Marauders</dt>
                <dt>My marauders</dt>
                <dt>Terms of use</dt>
              </dl></Col>
            </Row>
            <Row>
              <Col className='icon_row'>
                <img className='footer_icon' src={icon1}></img>
                <img className='footer_icon' src={icon2}></img>
                <img className='footer_icon' src={icon3}></img>
                <img className='footer_icon' src={icon4}></img>
              </Col>
            </Row>
            <div className='bottom_line'>SANDAGA LLC</div>
          </Container>
        </div>

      </div>

    </>
  )
}

export default Footer
